import React from 'react';
import { Redirect, Link } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import Articles from '../Articles'
import Hospitals from '../Hospitals'
import axios from 'axios';
import utils from '../../Utils';






import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import Loading from 'components/Loading'
import Header from 'components/Header'
import Question from './Question'
import Buttons from './buttons'
import SnackBar from 'components/SnackBar'
import style from 'style/quiz.css'

import { virtualize } from 'react-swipeable-views-utils';
import { mod } from 'react-swipeable-views-core';
import { Button } from '@material-ui/core';

// const VirtualizeSwipeableViews = virtualize(SwipeableViews);


const STEP_TEST = 'test'
const STEP_RESULT = 'result'
class Quiz extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      step: STEP_TEST,
      result: 0,
      redirectToLogin: false,
      sliderIndex: 0,
      answers: [],
      questions: [
        { q: 'لطفا جنسیت خود را مشخص کنید', a: ['زن', 'مرد'] },
        { q: 'استان محل سکونت را مشخص کنید', a: ['تهران ', 'قم', 'گیلان', 'سایر'] },
        { q: 'سن شما در کدام بازه قرار دارد؟', a: ['بین 20 تا 30 سال ', 'بین 30 تا 50 سال ', 'بالای 50 سال'] },
        { q: 'آیا هیچ یک از بیماریهای زمینه ای را دارید؟', a: ['بله ', 'خیر'], desc: 'فشار خون، بیماریهای قلبی، دیابت، بدخیمی، سابقه سکته مغزی، بیماری ریوی، نارسایی مزمن کلیه، نارسایی مزمن کبد، HIV ، مصرف داروهای تضعیف کننده ایمنی، شیمی درمانی و سابقه پیوند ' },
        { q: 'آیا تب دارید ', a: ['احساس تب ندارم  ', 'احساس تب دارم ولی اندازه گیری نکرده ام ', 'تب بین 37.5 تا 39 درجه دارم ', 'تب بیشتر از 39 درجه دارم '] },
        { q: 'آیا تنگی نفس دارید؟', a: ['تنگی نفس ندارم ', 'اخیرا دچار تنگی نفس شده ام ', 'بیش از دو هفته است که تنگی نفس دارم'], desc: 'احساس کم آوردن نفس در حالت استراحت یا مانع فعالیت عادی روزانه' },
        { q: 'آیا احساس بدن درد و خستگی بیش از حد دارید؟', a: ['احساس بدن درد ندارم ', 'اخیرا احساس بدن درد پیدا کرده ام', 'بیشتر از دو هفته است که دارم'] },
        { q: 'آیا سرفه خشک دارید ؟', a: ['سرفه ندارم ', 'اخیرا سرفه خشک دارم', 'بیشتر از دو هفته هست که دارم'] },
        { q: 'آیا احساس درد عضلانی دارید ؟', a: ['بله', 'خیر'], desc: 'درد جدید در عضلات که آزاد دهنده باشد' },
        { q: 'آیا سابقه تماس با فرد مبتلا به کرونا داشته اید ؟', a: ['بله', 'خیر'] },
      ]
    }
  }

  setAnswer = (index, value) => {
    if (!value) return
    const answers = [...this.state.answers]
    answers[index] = value
    // console.log(answers)
    this.setState({ answers: answers })
  }

  renderSlides = () => {
    return this.state.questions.map((question, index) => {
      return (
        <Question question={question} key={index} index={index} setAnswer={this.setAnswer} />
      )
    })
  }

  handleChangeIndex = index => {
    this.setState({ sliderIndex: index })
  }

  sendResult = async () => {

    this.setState({ loading: true })
    let result = await axios.post(utils.urls.calcCoronaURL, { answers: this.state.answers }).catch((e) => {
      console.log(e.response)
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.SnackBar.openSnackbar(message)
    });
    this.setState({ loading: false })

    if (!result) return
    // console.log(result, '###############')

    let { success, score } = result.data;
    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')
    this.setState({ result: score, step: STEP_RESULT })
  }

  nextSlide = () => {
    if (this.state.answers[this.state.sliderIndex] === undefined)
      return this.SnackBar.openSnackbar('سوال را پاسخ دهید')
    if (this.state.sliderIndex == 9)
      return this.sendResult()
    this.setState({ sliderIndex: this.state.sliderIndex + 1 })
  }

  prevSlide = () => {
    if (this.state.sliderIndex == 0)
      return
    this.setState({ sliderIndex: this.state.sliderIndex - 1 })
  }

  resetState = () => {
    this.setState({
      step: STEP_TEST,
      result: 0,
      sliderIndex: 0,
      answers: [],
    })
  }

  render() {
    if (this.state.redirectToLogin) {
      return <Redirect to='/login' />
    }
    return (
      <React.Fragment>
        <Header title="سامانه تشخیص کرونای طبینجا" showBackButton={true} desc='لطفا به سوالات زیر به دقت پاسخ دهید' ></Header>
        <div className="quiz-root">
          {this.state.loading && <Loading></Loading>}
          {!this.state.loading && this.state.step === STEP_TEST &&
            <div className='quiz-container'>
              <SnackBar ref={el => { this.SnackBar = el }}></SnackBar>

              <div className='slider-container'>
                <SwipeableViews slideStyle={{ height: '100%' }} containerStyle={{ height: '100%' }}
                  className='slider-root' index={this.state.sliderIndex} onChangeIndex={this.handleChangeIndex} axis="x-reverse"
                  disabled={true}>
                  {this.renderSlides()}
                </SwipeableViews>
              </div>
              <div className='quiz-footer'>
                <div className='prev-slide' onClick={this.prevSlide}>
                  <ChevronRightRoundedIcon />
                  قبلی
            </div>
                <div className='slide-number'> {this.state.sliderIndex + 1}/10</div>
                <div className='next-slide' onClick={this.nextSlide}>
                  بعدی
              <ChevronLeftRoundedIcon></ChevronLeftRoundedIcon>
                </div>
              </div>
            </div>
          }
          {!this.state.loading && this.state.step === STEP_RESULT &&
            <div className='result-container'>
              {this.state.result > 70 &&
                <>
                  <ul className='quiz-result card danger'>
                    <li>با توجه به علائم ذکر شده در ساعات آینده به یکی از بیمارستان های معین شده جهت رسیدگی به بیماران کرونا مراجعه کنید</li>
                    <li>لطفا در مسیرتردد از ماسک استفاده کنید و تماس با دیگران را به حداقل کاهش دهید</li>
                  </ul>
                  <Buttons onReload={this.resetState}></Buttons>
                  <a href='https://www.google.com/maps/d/viewer?mid=1zLU5JP0R21zsBK7kLOFhjk9Rujl2tw3s' className='link-map' target='blank'>
                    <div className='btn-map'>
                      <img src='/images/google-maps.png' />
                      <span>نمایش بیمارستانها بر روی نقشه</span>
                    </div>
                  </a>

                  {/* <Hospitals></Hospitals> */}
                </>
              }
              {(this.state.result <= 70 && this.state.result >= 50) &&
                <>
                  <ul className='quiz-result card warn'>
                    <li>با توجه به علائم ذکر شده، نیاز به توجه ویژه از سمت شما می باشد</li>
                    <li>شما هنوز نیازی به مراجعه به بیمارستان ندارید ولی نیاز است تا نسبت به قرنطینه خانگی اقدام کرده و کلیه وسائل خود را از سایرین جدا کنید و حتما از ماسک استفاده کنید</li>
                    <li>شما می بایست در صورت تشدید علائم مجددا 8 ساعت دیگر این تست را تکرار کنید</li>
                    <li>کلیه مراقبت های عمومی مانند شستشوی مرتب دست ها، خودداری استفاده از وسائل نقلیه عمومی، کاهش سفرهای غیر ضروری و در حضور در مکانهای شلوغ را رعایت فرمایید</li>
                  </ul>
                  <Buttons onReload={this.resetState}></Buttons>
                </>
              }
              {this.state.result < 50 &&

                <>
                  <ul className='quiz-result card ok'>
                    <li>با توجه به علائم ذکر شده شما نیاز به مراجعه به پزشک یا مرکز درمانی ندارید</li>
                    <li>خواهشمندیم برای حفاظت بیشتر در منزل بمانید</li>
                    <li>در صورت تغییر علائم میتوانید 8 ساعت دیگر مجددا تست را انجام دهید</li>
                    <li>برای مراقبت بیشتر از خود لطفا نکات بهداشتی و ایمنی را رعایت فرمایید</li>
                    <li>شستشوی مرتب دست ها، خودداری استفاده از وسائل نقلیه عمومی، کاهش سفرهای غیر ضروری و در حضور در مکانهای شلوغ</li>
                  </ul>
                  <Buttons onReload={this.resetState}></Buttons>

                </>
              }
              <Articles style={{ backgroundColor: '#fff', marginTop: 10, flexShrink: 0 }}></Articles>
            </div>
          }
        </div>
      </React.Fragment >
    )
  }

}

export default Quiz